import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'activity', 'Activity', [["path",{"d":"M3 12h4l3 8l4 -16l3 8h4"}]]);